"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _handleActions;

var _reduxActions = require("redux-actions");

var _constants = require("./constants");

var C = _interopRequireWildcard(_constants);

var _auth = require("../../../reducers/auth");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
    appUserProfile: null,
    appUserProfileState: { value: null }
};
var handleAppUserProfile = function handleAppUserProfile(state, action) {
    return {
        appUserProfileState: action.payload,
        appUserProfile: action.payload.value
    };
};
exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, C.USER_PROFILE_SUCCESS, handleAppUserProfile), _defineProperty(_handleActions, C.USER_PROFILE_FAILED, handleAppUserProfile), _defineProperty(_handleActions, C.USER_PROFILE, handleAppUserProfile), _defineProperty(_handleActions, _auth.AUTH_GLOBAL_SECURITY_ERROR, function (state, action) {
    return Object.assign({}, initialState);
}), _defineProperty(_handleActions, _auth.AUTH_LOGOUT, function (state, action) {
    return Object.assign({}, initialState);
}), _handleActions), initialState);
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/reducers/user/index.ts
 ** module id = 1299
 ** module chunks = 0
 **/